<template>
  <div id="app">
    <div class="container hidden-sm-and-down">
      <img src="../assets/images/shoulu.jpg" alt="" width="100%" class="five" />
    </div>
    <div class="body_bg">
      <div class="container" style="margin-top: 15px !important">
        <el-row :gutter="15">
          <Mlogin />
          <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19" class="main-content">
            <el-row :gutter="15">
              <el-col :xs="24" :sm="24" :md="17" :lg="17" :xl="17" class="left">
                <div class="tgxz">
                  <div class="title3">
                    <div class="titleall3">Journal introduction</div>
                    <span class="title_more3">
                      <router-link to="/FixedBody?ItemId=11"></router-link>
                    </span>
                    <div class="clearfix"></div>
                  </div>
                  <div v-html="getbody" class="pd15" style="padding-top: 0"></div>
                </div>
                <div class="dqml fifth">
                  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                    <el-tab-pane label="Current Issue" name="first" class="buttona">
                      <IssueArticleListControl :type="type" v-if="isyuchuban == false" :List="List" :isdataa="true"
                        :newListTitle="newListTitle" :Periods="Periods" :id="1" :scroll="true" :CloumnList="CloumnList">
                      </IssueArticleListControl>
                    </el-tab-pane>
                    <el-tab-pane label="Pre-publication" class="buttona" name="second" v-if="isycb">
                      <IssueArticleListControl :type="type" v-if="isyuchuban" :isycb="isycb" :List="newList"
                        :Periods="Periods" :id="1" :scroll="true"></IssueArticleListControl>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7" class="left">
                <!-- 新闻动态 -->
                <div class="tgxz" style="background: #fff !important">
                  <div class="title">
                    <div class="titleall">News</div>
                    <span class="title_more">
                      <router-link to="/NewsList?ColumnId=18"></router-link>
                    </span>
                    <div class="clearfix"></div>
                  </div>
                  <Control :params="{ ColumnId: 18, PageSize: 3 }"></Control>
                </div>
                <!-- 期刊信息 -->
                <div class="tgxz tentn" style="background: #fff !important">
                  <div class="title">
                    <div class="titleall">Periodical Information</div>
                    <div class="clearfix"></div>
                  </div>
                  <div style="text-align: center">
                    <img :src="ImgUrl + imgUrl" alt width="100%" class="issueImg" />
                  </div>
                  <div v-html="Info" class="notice"></div>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <DocumentsNewsBlockControl></DocumentsNewsBlockControl>
        </el-row>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import FixedBlockControl from '../components/Home/FixedBlockControl'
import IssueArticleListControl from '../components/IssueArticleListControl/IssueArticleListControl'
import xiazai from '@/assets/js/xiazai'
import vueQr from 'vue-qr'
import Control from '../components/DocumentsNewsBlockControl/page/Control'


export default {
  data() {
    return {
      keywords: '',
      activeName: 'first',
      data: {},
      newList: [],
      List: [],
      Lista: [],
      isyuchuban: false,
      cotype: '',
      Periods: {},
      FileGUID: '',
      type: 0,
      SetItem: {},
      isycb: false,
      isycba: false,
      isLoginDown: false,
      isEBt: false,
      newListTitle: '',
      recomList: [],
      recomLista: [],
      recomListb: [],
      recomListc: [],
      codeId: 0,
      centerDialogVisible: false,
      CloumnList: [],
      getDynamic: [],
      imgUrl: '',
      Info: '',
      listjournalScroll: [],
      getbody: '',
      listData: [],
    }
  },
  components: {
    FixedBlockControl,
    IssueArticleListControl,
    vueQr,
    Control,
  },
  created() {
    this.getArticList()
    this.GetIssue()
    this.getSet() //获取系统配置
    this.GetRecomList() //推荐列表
    this.getDynamicList() //获取期刊动态滚动图片
    this.getProfiles() //获取期刊信息
    this.scrollList() // 滚动列表
    this.getProfile() //期刊简介
    this.getnewslist()
  },
  computed: {
    classOption() {
      return {
        step: 0.3, // 数值越大速度滚动越快
      }
    },
  },
  mounted() {
    if (this.$route.query.code) {
      this.$store
        .dispatch('_getWeiXinLogin', { Scene: this.$route.query.code })
        .then((res) => {
          localStorage.setItem('userInfo', JSON.stringify(res.data.Data))
        })
    }
  },
  methods: {
    getnewslist() {
      let data = { ColumnId: 2 }
      this.$store
        .dispatch('_getActor', data)
        .then((res) => {
          this.listData = res.data.Data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getProfiles() {
      let data = [13]
      this.$store.dispatch('_getHeader', data).then((res) => {
        if (res.data.IsSuccess) {
          if (res.data.Data.length > 0) {
            this.Info = res.data.Data[0].Body
          }
        }
      })
    },
    getProfile() {
      let data = [1101]
      this.$store.dispatch('_getHeader', data).then((res) => {
        if (res.data.IsSuccess) {
          if (res.data.Data.length > 0) {
            this.getbody = res.data.Data[0].Body
          }
        }
      })
    },
    getSet() {
      let params = [
        1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 2960,
        2900, 4553,
      ]
      //1000:期刊名称
      //1001：期刊英文名称
      //4530：（否）隐藏/（是）显示预出版模块
      //6018:预出版模块显示 （否）文章列表/（是）预出版内容
      //6019：是否需要登录下载文件
      //230：显示/隐藏所有的评论功能
      //6055：显示/隐藏列表和详情页的英文标题，英文关键字，英文摘要
      //5000： ISSN编号
      //5010：CN编号
      //11:是否启用手机短信
      //2900:是否启用英文网刊
      this.$store
        .dispatch('_getSet', params)
        .then((res) => {
          this.SetItem = res.data.Data
          sessionStorage.setItem('SetItem', JSON.stringify(res.data.Data))
          this.SetItem.map((item) => {
            if (item.SetItemID == 4530) {
              item.Item_Value == '是'
                ? (this.isycb = true)
                : (this.isycb = false)
            }
            if (item.SetItemID == 4553) {
              this.printNum = item.Item_Value
            }
            if (item.SetItemID == 6018) {
              if (item.Item_Value == '是') {
                this._getLista(this.printNum)
              } else {
                this._getListb(this.printNum)
              }
            }
            if (item.SetItemID == 6019) {
              item.Item_Value == '是'
                ? (this.isLoginDown = true)
                : (this.isLoginDown = false)
            }
            //   if(item.SetItemID==6055){
            //  item.Item_Value="是"?this.isEBt=true:this.isEBt=false
            //   }
          })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    godigese(ids) {
      this.$newOpen('/#/digest?ArticleID=' + ids)
    },

    oniscode(num) {
      this.centerDialogVisible = true
      this.codeId = num
    },
    handleClick(tab, event) {
      if (tab.index == '1') {
        this.type = 1
        this.isyuchuban = true
        this.newList = this.Lista
      }
      if (tab.index == '0') {
        this.type = 0
        this.isyuchuban = false
        this.newList = this.List
      }
    },
    getArticList() {
      let params = {
        PageSize: 0,
        IssueId: 0,
      }
      this.$store
        .dispatch('_getNewlist', params)
        .then((res) => {
          this.List = res.data.Data
          this.Listb = res.data.Data
          this.List.map((item) => {
            if (item.Column) {
              this.CloumnList.push(item)
            }
          })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    goExport(ids) {
      this.$newOpen('/#/Export?ids=' + ids)
    },
    GetIssue() {
      this.$store
        .dispatch('_getYear', { Id: -1 })
        .then((res) => {
          this.newListTitle = res.data.Data.YearIssue_NoTtitle
          this.imgUrl = res.data.Data.CoverGUID + res.data.Data.CoverSuffix
          let data = {
            newYears: res.data.Data.Publish_Date,
            Volume: res.data.Data.Volume,
            CoverGUID: res.data.Data.CoverGUID,
            CoverSuffix: res.data.Data.CoverSuffix,
            YearIssue_NoTtitle: res.data.Data.YearIssue_NoTtitle,
          }

          sessionStorage.setItem('newYears', JSON.stringify(data))
          this.Periods = res.data.Data
          // if (res.data.Data.CoverGUID) {
          //   this.CoverGUID = true;
          // }
          // if (res.data.Data.BackCoverGUID) {
          //   this.BackCoverGUID = true;
          // }
          // if (res.data.Data.CoverGUID) {
          //   this.TableConGUID = true;
          // }
          // if (res.data.Data.RSS) {
          //   this.Rss = true;
          // }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    GetRecomList() {
      var time = new Date().getTime()
      let data = {
        PageSize: 4,
        Type: 'Sort',
        Key: 'Recommended',
        PageIndex: 1,
      }
      this.$store
        .dispatch('_getListb', data)
        .then((res) => {
          if (res.data.IsSuccess) {
            this.recomListc = res.data.Data
            for (let i = 0; i < this.recomListc.length; i++) {
              if (i < 2) {
                this.recomLista.push(this.recomListc[i])
              } else {
                this.recomListb.push(this.recomListc[i])
              }
            }
            this.recomList.push(this.recomLista)
            this.recomList.push(this.recomListb)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    pdf(i, size, guid) {
      if (size <= 0) {
        alert('文件不存在')
        return
      }
      this.$store.dispatch('_getPDF', { Id: guid }).then((Result) => {
        window.location.href = Result.request.responseURL
      })
    },
    goHtml(url) {
      window.open(url, '_blank')
    },
    _getLista(num) {
      var time = new Date().getTime()
      this.$store
        .dispatch('_getLista', {
          PageSize: num,
          src: time,
        })
        .then((res) => {
          if (res.data.IsSuccess) {
            this.Lista = res.data.Data
          }
        })
        .catch((err) => {
          console.log(err, 'err')
        })
    },
    _getListb(num) {
      var time = new Date().getTime()
      this.$store
        .dispatch('_getListb', {
          PageSize: num,
          Type: 'Sort',
          Key: 'Preprint',
          src: time,
        })
        .then((res) => {
          if (res.data.IsSuccess) {
            this.Lista = res.data.Data
          }
        })
        .catch((err) => {
          console.log(err, 'err')
        })
    },
    getDynamicList() {
      this.$store
        .dispatch('_getBannerList', { ID: 1 })
        .then((res) => {
          this.getDynamicList = res.data.Data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 滚动图获取图片
    scrollList() {
      this.$store
        .dispatch('_getBannerList', { ID: 1 })
        .then((res) => {
          if (res.data.IsSuccess) {
            if (res.data.Data.length > 0) {
              this.listjournalScroll = res.data.Data.reverse()
            }
          }
        })
        .catch((err) => {
          console.log(err, 'err')
        })
    },
  },
}
</script>

<style>
.seamless-warp2 {
  overflow: hidden;
  height: 190px;
  width: 100%;
}

.seamless-warp2 div:nth-child(1) {
  width: 1200px !important;
}

ul.item {
  width: 100%;
}

ul.item li {
  float: left;
  margin-left: 8px;
  margin-right: 8px;
}

ul.item li img {
  width: 134px;
  height: 189px;
}

a {
  color: #222222;
}

.qkjj .el-carousel {
  background: #fff;
}

.qkjj .el-carousel__item {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.item_banner .el-row {
  border: 1px #f1f1f1 solid;
  width: 48%;
  text-align: center;
  padding: 10px 12px;
  min-height: 284px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.09) 0px 6px 9px 0px;
  -moz-box-shadow: rgba(0, 0, 0, 0.09) 0px 6px 9px 0px;
  box-shadow: rgba(0, 0, 0, 0.09) 0px 6px 9px 0px;
}

.qkjj .el-carousel__indicators--horizontal {
  bottom: 20px;
}

.content span {
  margin-right: 15px;
  height: 21px;
  line-height: 21px;
  display: inline-flex;
}

.text {
  text-align: left;
}

.text .title {
  color: #00777b;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
}

.qkjj .el-carousel--horizontal {
  overflow: hidden;
}

.text .author {
  line-height: 1.5;
  margin-bottom: 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.text .contentText {
  color: #6f6f6f;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  line-height: 1.5;
  margin-bottom: 5px;
  height: 40px;
}

.content span {
  cursor: pointer;
}

.content span i {
  display: inline-block;
  width: 19px;
  height: 19px;
  background: url('../assets/images/colum_arrow.png') no-repeat;
}

.content span .icon1 {
  background-position: 0px 2px;
}

.content span .icon2 {
  background-position: 0px -17px;
}

.content span .icon3 {
  background-position: 0px -36px;
}

.el-tabs--card>.el-tabs__header .el-tabs__item {
  border-bottom: none !important;
}

.dqml .el-tabs__nav-scroll {
  background: #f0f2f0;
  border-bottom: 2px #f99f03 solid;
}

.dqml .el-tabs__nav-scroll .el-tabs__item {
  border-bottom: none !important;
}

.el-carousel__indicator.is-active button {
  background: #fff !important;
}

.el-carousel__item {
  background: #dedede;
}

.text_carousel {
  background: #000;
  opacity: 0.8;
  height: 30px;
  line-height: 30px;
  color: #fff;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media (max-width: 992px) {
  .carousel_pic {
    margin-bottom: 15px;
  }
}

.qkdtbanner {
  width: 270px;
  height: 198px;
}

.issueImg {
  width: 200px;
  border: 1px #e3c2ac solid;
}

.tabcurrent {
  background: #edad48;
  color: #fff;
}

#infopic {
  line-height: 26px;
}

.seamless-warp {
  height: 160px;
  overflow: hidden;
}
</style>
